var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-2 input-element"},[_c('div',{staticClass:"col-12 booleanLabel",domProps:{"innerHTML":_vm._s(_vm.fieldText)}}),(_vm.subText)?_c('div',{staticClass:"col-12 subLabel",domProps:{"innerHTML":_vm._s(_vm.subText)}}):_vm._e(),_c('div',{staticClass:"col-12 input"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }